<template>
  <div>
    <div class="searchbox">
      <form action="#" method="get" class="form-inline form-float" @submit.prevent>
        <div class="form-group">
          <label for="a_name">可通过路段:</label>
          <input
            class="form-control"
            type="text"
            placeholder
            size="12"
            v-noBlankSpace
          />
        </div>
        <div class="form-group">
          <label for="a_name">车场ID:</label>
          <input
            class="form-control"
            type="text"
            placeholder
            size="12"
            v-noBlankSpace
          />
        </div>
        <div class="form-group">
          <label for="a_name">卡号查询:</label>
          <input
            class="form-control"
            type="text"
            placeholder
            size="12"
            v-noBlankSpace
          />
        </div>

        <div class="form-group others">
          <span class="search_btn">
            <el-button type="primary" :loading="loading" @click="handleSearch"  size="small">
              查询
            </el-button>
          </span>

          <span class="add_btn">
            <el-button type="default" @click="handleAdd">
              添加
            </el-button>
          </span>
        </div>
      </form>
    </div>
    <div class="list-right">
      <el-table
        ref="table"
        border
        :data="tableListData"
        height="100%"
        :header-cell-style="tableHeaderStyle"
        :cell-style="styleObj"
        v-loading="loading"
      >
        <el-table-column
          show-overflow-tooltip
          label="编号"
          prop="name"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="街道"
          prop="contact"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="路段"
          prop="mobile"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="车场ID"
          prop="address"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="卡号"
          prop="crtUserName"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="车位数量"
          prop="crtUserName"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="剩余车位"
          prop="crtUserName"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="设备状态"
          prop="crtUserName"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="通信时间"
          prop="crtUserName"
        ></el-table-column>
        <el-table-column show-overflow-tooltip label="操作">
          <template slot-scope="scope">
            <button class="edit operate-button" type="button">
              修改
            </button>
            <button class="delete operate-button" type="button">
              删除
            </button>
         
          </template>
        </el-table-column>
      </el-table>
    </div>
    <Page v-on:pagination="receivePaginationData" v-bind:pageObj="pageObj"></Page>
  </div>
</template>
<script>
import Page from "../../commons/page.vue";
export default {
  name:'space-information',
  data() {
    return {
      loading: false,
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },

      tableListData: [],
      form: {
        id: "",
        name: "",
        contact: "",
        mobile: "",
        address: "",
        crtUserName: "",
      },

      search: {
        pageNumber: 1,
        pageSize: 10,
        name: "",
      },

      formLabelWidth: "100px",
      pageObj:{}
    };
  },
  methods: {
    async handleSearch() {
      this.loading = true;
      try {
        // TODO: 实现搜索逻辑
        await this.getTableList();
      } finally {
        this.loading = false;
      }
    },
    handleAdd() {
      // TODO: 实现添加逻辑
    },
    async getTableList() {
      // TODO: 实现获取表格数据的逻辑
    },
    receivePaginationData(v1, v2) {},
  },

  components: {
    Page,
  },
};
</script>
